import { render, staticRenderFns } from "./CloudWorks.vue?vue&type=template&id=0471963d&scoped=true&"
import script from "./CloudWorks.vue?vue&type=script&lang=js&"
export * from "./CloudWorks.vue?vue&type=script&lang=js&"
import style0 from "./CloudWorks.vue?vue&type=style&index=0&id=0471963d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471963d",
  null
  
)

export default component.exports